'use client';

import { SessionProvider } from 'next-auth/react';
import { AuthContextProvider } from '@/context/AuthContext';
import { CartProvider } from '@/context/CartContext';
import Header from '@/components/Header';
import Cart from '@/components/Cart';

export default function Providers({ children }) {
  return (
    <SessionProvider>
      <AuthContextProvider>
        <CartProvider>
          <Header />
          <Cart />
          <main className="flex-grow">
            {children}
          </main>
          <footer className="bg-primary-100 border-t mt-12">
            <div className="container mx-auto px-4 py-8">
              <div className="text-center text-primary-800 text-sm">
                &copy; {new Date().getFullYear()} EasyEDITools Online Store. All rights reserved.
              </div>
            </div>
          </footer>
        </CartProvider>
      </AuthContextProvider>
    </SessionProvider>
  );
} 
